import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateLaudoHigienizacao,
  IEditLaudoHigienizacao,
} from './laudo-higienizacao.model';

@Injectable({
  providedIn: 'root',
})
export class LaudoHigienizacaoService {
  constructor(private http: HttpClient) {}

  CreateLaudoHigienizacao(
    body: ICreateLaudoHigienizacao,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid,
    });
    return this.http.post<any>(
      `${environment.baseURL}LaudoServico/CreateLaudoServicos`,
      body,
      { headers: headers }
    );
  }

  public EditarLaudoHigienizacao(
    pkLaudoHigienizacao: number,
    body: IEditLaudoHigienizacao
  ): Observable<any> {
    const url = `${environment.baseURL}LaudoServico/UpdateLaudoServicos?id=${pkLaudoHigienizacao}`;

    return this.http.put<any>(url, body);
  }
  public GetLaudoHigienizacaoPaginated({
    PK_LAUD_SRVC,
    FK_GATE_ENTR,
    FK_EPSA,
    TX_PLCA_CAVA,
    DT_GATE_ENTR_INIC,
    DT_GATE_ENTR_FIM,
    pageNumber,
    pageSize,
    paginar = true,
    status = 1,
  }: {
    PK_LAUD_SRVC?: number | null;
    FK_GATE_ENTR?: number | null;
    FK_EPSA?: number | null;
    TX_PLCA_CAVA: string | null;
    DT_GATE_ENTR_INIC?: string | null;
    DT_GATE_ENTR_FIM?: string | null;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
    status?: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, null, NaN];
    const url = `${environment.baseURL}LaudoServico/GetLaudoServicosPaginated`;
    const params: any = {};

    if (!invalid.includes(PK_LAUD_SRVC)) {
      params.PK_LAUD_SRVC = PK_LAUD_SRVC;
    }
    if (!invalid.includes(FK_GATE_ENTR)) {
      params.FK_GATE_ENTR = FK_GATE_ENTR;
    }
    if (!invalid.includes(FK_EPSA)) {
      params.FK_EPSA = FK_EPSA;
    }

    if (!invalid.includes(TX_PLCA_CAVA)) {
      params.TX_PLCA_CAVA = TX_PLCA_CAVA;
    }

    if (!invalid.includes(DT_GATE_ENTR_INIC)) {
      params.DT_GATE_ENTR_INIC = DT_GATE_ENTR_INIC;
    }

    if (!invalid.includes(DT_GATE_ENTR_FIM)) {
      params.DT_GATE_ENTR_FIM = DT_GATE_ENTR_FIM;
    }

    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }

    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }

    if (!paginar) {
      const numeroMaximoRegistros = 2147483647;
      params.PAGE_SIZE = numeroMaximoRegistros;
    }

    return this.http.get<any>(url, { params });
  }

  public GetLaudoHigienizacaoById(id?: number): Observable<any> {
    let url = `${environment.baseURL}LaudoServico/GetLaudoServicosById`;
    if (id !== undefined) {
      url += `?id=${id}`;
    }
    return this.http.get<any>(url);
  }

  public GetReceiptLaudoHigienizacaoById(id: number): Observable<any> {
    const url = `${environment.baseURL}LaudoServico/GetReceiptLaudoServicoId`;
    const params: any = {};

    params.PK_LAUD_SRVC = id;
    params.FL_TIPO_DOCU = 0;

    return this.http.get<any>(url, { params });
  }
}
